import { hashString, getValueByPath } from '@shared/utils';

export class LazyDropdownOption<T> {
  selected = false;
  highlighted = false;
  display: string;
  description: string;
  value: any;
  id: string;
  disabled = false;

  static generateIdFromOption(value: any): string {
    if (value && typeof value === 'object' && value.id !== undefined) {
      return String(value.id);
    }

    return `${hashString(`${JSON.stringify(value).replace(/[{}\[\],"]/g, '')}`)}`;
  }

  constructor(
    public option: T,
    public index: number,
    valuePath: string,
    displayPath: string,
    descriptionPath?: string
  ) {
    this.display = getValueByPath(option, displayPath);
    this.description = descriptionPath ? getValueByPath(option, descriptionPath) : undefined;
    this.value = getValueByPath(option, valuePath);
    this.id = LazyDropdownOption.generateIdFromOption(this.value);
  }

  isEqualTo(option: LazyDropdownOption<T>): boolean {
    return this.id === option.id;
  }
}
